import { APIKit } from "config/axios";

import { ServerConstants } from "constant";
import { Bank } from "types";
import { FileUtils } from "utils";

const { API_V1_XML } = ServerConstants;

const XML_ENDPOINTS: Partial<Record<Bank, string>> = {
  BANK_NOW: "bank-now",
  CEMBRA_MONEY_AG: "cembra",
};

export async function downloadBankXml(bank: Bank, clientId: number, clientFullName?: string) {
  const endpoint = XML_ENDPOINTS[bank];

  if (!endpoint) {
    throw new Error(`XML export is not supported for bank ${bank}`);
  }

  const response = await APIKit.get(`${API_V1_XML}/${endpoint}/${clientId}`, {
    responseType: "blob",
  });

  const blob = new Blob([response.data], { type: "application/xml" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FileUtils.buildClientDocumentFileName(clientFullName, "xml");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
